var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
export var IconContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var IconContainerLeft = styled(IconContainer)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-right: ", ";\n"], ["\n  margin-right: ", ";\n"])), rem(10));
var IconContainerRight = styled(IconContainer)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-left: ", ";\n"], ["\n  margin-left: ", ";\n"])), rem(10));

var ButtonContent = function ButtonContent(_a) {
  var children = _a.children,
      className = _a.className,
      leftIcon = _a.leftIcon,
      rightIcon = _a.rightIcon;
  return React.createElement("div", {
    className: className
  }, leftIcon && React.createElement(IconContainerLeft, null, leftIcon), children && children, rightIcon && React.createElement(IconContainerRight, null, rightIcon));
};

ButtonContent.defaultProps = {
  children: null,
  leftIcon: null,
  rightIcon: null,
  className: null
};
export default styled(ButtonContent)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;